export default __webpack_public_path__ + "static/media/640_business02-fr-mobile.023584a2.png";